'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M832 192h-64v128h-192v-128h-192v128h-192v-128h-64c-35.2 0-64 28.8-64 64v704c0 35.2 28.8 64 64 64h704c35.2 0 64-28.8 64-64v-704c0-35.2-28.8-64-64-64zM256 960h-127.886c-0.040-0.034-0.082-0.076-0.114-0.116v-127.884h128v128zM256 768h-128v-128h128v128zM256 576h-128v-128h128v128zM448 960h-128v-128h128v128zM448 768h-128v-128h128v128zM448 576h-128v-128h128v128zM640 960h-128v-128h128v128zM640 768h-128v-128h128v128zM640 576h-128v-128h128v128zM832 959.884c-0.034 0.040-0.076 0.082-0.116 0.116h-127.884v-128h128v127.884zM832 768h-128v-128h128v128zM832 576h-128v-128h128v128zM320 128c0-17.672-14.328-32-32-32s-32 14.328-32 32v128h64v-128zM704 128c0-17.672-14.328-32-32-32s-32 14.328-32 32v128h64v-128z' })
    ));
};